var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-list-tile',{on:{"click":function($event){return _vm.$emit('eventoCancelarEnvioHomologacao')}}},[_c('v-list-tile-title',[_vm._v(" Cancelar Envio ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }